import {Modal} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../../components/MDButton";
import {InputAdornment} from "@mui/material";
import MDInput from "../../../components/MDInput";
import {addToCart} from "../../common/api/PortalCustomerApi";
import {CartContext} from "../../../lib/CartProvider";
import {Add, Remove} from "@mui/icons-material";
import InventoryModalBody from "./InventoryModalBody";
import {UserContext} from "../../../lib/UserProvider";

export default function ViewInventoryModal(props) {

  const [cartContext, setCartContext] = useContext(CartContext);

  const [userContext, setUserContext] = useContext(UserContext);
  const [authenticated, setAuthenticated] = useState(userContext?.sessionUser?.guid?.length > 0);

  useEffect(() => {
    setAuthenticated(userContext?.sessionUser?.guid?.length > 0);
  }, [userContext]);

  const [siblingRenderIndex, setSiblingRenderIndex] = useState(1);
  const [inventory, setInventory] = useState(props.event);
  const [addingToCart, setAddingToCart] = useState(false);
  const [maxQuantity, setMaxQuantity] = useState(props?.inventory?.unlimited ? 999 : props?.inventory?.quantity);
  const [maxAmount, setMaxAmount] = useState(props?.inventory?.maxAmount || 0);

  const [membershipType, setMembershipType] = useState(false);

  useEffect(()=> {
    setMembershipType(props?.membershipType)
  }, [props?.membershipType])

  const [inventoryType, setInventoryType] = useState(props.inventoryType);
  const [formInvalid, setFormInvalid] = useState(false);
  const [addFamily, setAddFamily] = useState(false);

  const [isNew, setIsNew] = useState(!!!props.inventoryType?.guid);
  const [quantity, setQuantity] = useState(1);
  const [siblingQuantity, setSiblingQuantity] = useState(0);
  const [giftCardAmount, setGiftCardAmount] = useState(0);
  const [giftCardRecipientName, setGiftCardRecipientName] = useState();
  const [giftCardRecipientEmail, setGiftCardRecipientEmail] = useState();
  const [giftCardRecipientMessage, setGiftCardRecipientMessage] = useState();
  const [giftCardRecipientSendDate, setGiftCardRecipientSendDate] = useState();
  const [giftCardDeliverFuture, setGiftCardDeliverFuture] = useState(false);

  const [cafeOptions, setCafeOptions] = useState([]);
  const [giftCardValid, setGiftCardValid] = useState(true);

  useEffect(() => {
    setItems('');
  }, [props]);

  useEffect(() => {
    setInventory(props?.inventory);
    if (props?.inventory?.giftCard) {
      setGiftCardAmount(props?.inventory?.minAmount);
      setGiftCardValid(false);
    }
  }, [props?.inventory]);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventoryType)
  });


  const addToCartFn = async (item) => {
    setAddingToCart(true);
    let _e = {...item};
    _e.quantity = quantity;
    _e.giftCardAmount = giftCardAmount;
    _e.membershipMembers = membershipMembers;

    let giftRecipient = {
      recipientName: giftCardRecipientName,
      email: giftCardRecipientEmail,
      message: giftCardRecipientMessage,
      sendDate: giftCardRecipientSendDate,
      deliverFuture: giftCardDeliverFuture
    }
    _e.giftRecipient = giftRecipient;
    _e.cafeOptions = cafeOptions;

    addToCart(_e).then((result) => {
      handleClose();
      setAddingToCart(false);
      setCartContext({...cartContext, reloadCart: false, viewCart: true, caller: 'View inventory add to cart'});
    });
  };

  const handleClose = () => {
    props.handleClose();
  };

  const handleSave = () => {
    addToCartFn(inventory);
  };

  const [items, setItems] = useState('');
  const itemCallback = (condition, quantity) => {
    setItems(condition);
    setSiblingQuantity(quantity);
  }

  const [cafeValid, setCafeValid] = useState(true);

  const [membershipValid, setMembershipValid] = useState(true);
  const [membershipMembers, setMembershipMembers] = useState([]);

  const [doSubmit, setDoSubmit] = useState(1);

  return (
    <>
      {inventory &&
        <Modal onHide={handleClose} size={'lg'} fullscreen={true} dialogClassName={'psb-page-overlay'} show={props.show}>
          <Modal.Header closeButton>
            <Modal.Title>{inventory.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <InventoryModalBody
              key={inventory.guid}
              itemCallback={itemCallback}
              inventory={inventory}
              quantity={quantity}
              doSubmit={doSubmit}
              full={true}
              addFamilyCallback={(isAddFamily) => {
                setAddFamily(isAddFamily);
              }}
              giftCardRecipientCallback={(e) => {
                setGiftCardRecipientName(e.giftCardRecipientName);
                setGiftCardRecipientEmail(e.giftCardRecipientEmail);
                setGiftCardRecipientMessage(e.giftCardRecipientMessage);
                setGiftCardRecipientSendDate(new Date(e.giftCardRecipientSendDate));
                setGiftCardDeliverFuture(e.giftCardDeliverFuture ? true : false);
                setGiftCardAmount(parseFloat(e.giftCardAmount).toFixed(2));
              }}
              formCallback={(validCard)=>{
                setGiftCardValid(validCard);
              }}
              membershipCallback={(cb) => {
                setMembershipValid(cb?.membershipValid);
                setMembershipMembers(cb?.membershipMembers);
              }}
              cafeCallback={(cb) => {
                setCafeValid(cb?.orderValid);
                setCafeOptions(cb?.cafeOptions);
              }}/>

          </Modal.Body>
          <Modal.Footer>

            {!membershipType && !inventory?.giftCard &&
              <MDInput type="text" step="1" required
                       onChange={(e) => {
                         setQuantity(e.target.value);
                       }}
                       InputProps={{
                         readOnly: true,
                         startAdornment: <InputAdornment position="start"
                                                         className={'cursor-pointer'}
                                                         onClick={(e) => {
                                                           let _q = quantity - 1;
                                                           if (_q > 0) {
                                                             setQuantity(_q);
                                                           }
                                                         }}>
                           <Remove/>
                         </InputAdornment>,
                         endAdornment: <InputAdornment position="end"
                                                       className={'cursor-pointer'}
                                                       onClick={(e) => {
                                                         let _q = quantity;
                                                         if (_q + 1 <= maxQuantity) {
                                                           setQuantity(_q + 1);
                                                         }
                                                       }}>
                           <Add/>
                         </InputAdornment>,
                       }}
                       value={quantity || 1}
                       autoComplete="off"
                       className="form-control" id="quantity"
                       label="Quantity"
                       style={{width: '125px'}}/>
            }

            {addFamily && <MDButton type={"button"}
                                    onClick={() => {
                                      setDoSubmit(doSubmit + 1);
                                    }}
                                    form={"lockedAccountMemberForm"}
                                    variant="gradient"
                                    color="info"
            >Save
            </MDButton>
            }
            {!addFamily &&
              <MDButton
                type="button"
                onClick={()=>{
                  handleSave()
                }}
                variant="gradient"
                color="info"
                style={{marginLeft: '10px'}}
                disabled={addingToCart || formInvalid || (authenticated && !membershipValid) || !cafeValid || !giftCardValid}>
                {addingToCart ? 'Adding to Cart...' : <>Add&nbsp;{items && items}to Cart</>}
              </MDButton>
            }

          </Modal.Footer>
        </Modal>
      }
    </>
  );
}